import escapeHtml from 'escape-html';
import { Text as TextSlate } from 'slate';

const slateSerialize = (node) => {
  if (TextSlate.isText(node)) {
    let string = escapeHtml(node.text);
    if (node.bold) {
      string = `<strong>${string}</strong>`;
    }
    if (node.italic) {
      string = `<em>${string}</em>`;
    }
    if (node.underline) {
      string = `<u>${string}</u>`;
    }
    return string;
  }

  const childrenAsText = node.children.map((n) => slateSerialize(n)).join('');

  switch (node.type) {
    case 'paragraph':
      return `<p>${childrenAsText}</p>`;
    case 'numbered-list':
      return `<ol>${childrenAsText}</ol>`;
    case 'bulleted-list':
      return `<ul>${childrenAsText}</ul>`;
    case 'list-item':
      return `<li>${childrenAsText}</li>`;
    case 'link':
      // Guard against missing URL (e.g. <a> without href deserialized as url: undefined).
      // Rendering href="undefined" produces an invalid anchor, so fall back to plain text.
      if (!node.url) {
        return childrenAsText;
      }
      return `<a href="${escapeHtml(node.url)}" target="_blank" rel="noopener noreferrer">${childrenAsText}</a>`;
    default:
      return childrenAsText;
  }
};

export default slateSerialize;
